import { createAppointment } from '../appointments';

export interface AppointmentPayload {
  client_name: string;
  client_email?: string;
  client_phone?: string;
  city?: string;
  date: string;
  time_start?: string;
  service?: string;
  notes?: string;
  appointment_type?: 'call' | 'in_person' | 'online' | string;
  status?: 'requested' | 'confirmed' | 'canceled';
  lead_id?: string;
}

export interface SafeResult<T> {
  ok: boolean;
  data?: T;
  error?: string;
}

export async function createAppointmentSafe(
  payload: AppointmentPayload
): Promise<SafeResult<any>> {
  try {
    // Mapear tipos de español a inglés
    let appointmentType = payload.appointment_type;
    if (appointmentType === 'llamada') {
      appointmentType = 'call';
    } else if (appointmentType === 'presencial') {
      appointmentType = 'in_person';
    }

    // Validación de teléfono según tipo de cita
    if ((appointmentType === 'call' || appointmentType === 'in_person') && 
        (!payload.client_phone || payload.client_phone.trim() === '')) {
      return {
        ok: false,
        error: 'El teléfono es obligatorio para citas de tipo llamada o presencial'
      };
    }

    // Preparar datos para la BD
    const appointmentData = {
      client_name: payload.client_name,
      client_email: payload.client_email || null,
      client_phone: payload.client_phone || null,
      city: payload.city || null,
      date: payload.date,
      time_start: payload.time_start || '10:00',
      status: payload.status || 'requested',
      notes: payload.notes || null,
      lead_id: payload.lead_id || null,
    };

    // Llamar a la función existente
    const appointment = await createAppointment(appointmentData);

    // Si llegamos aquí, fue exitoso
    return {
      ok: true,
      data: appointment
    };
  } catch (error: any) {
    // Capturar cualquier error y devolverlo de forma segura
    const errorMessage = error?.message || error?.toString() || 'Error desconocido al crear la cita';
    
    return {
      ok: false,
      error: errorMessage
    };
  }
}
